import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const AiKnowledgeSourceIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-knowledge-source'),
      meta: { permissions: ['administrator'] },
      component: SettingsWrapper,
      props: {
        headerTitle: 'AI_AGENTS.KNOWLEDGE.SETTINGS_TITLE',
        icon: 'i-lucide-book-open',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'ai_knowledge_sources_settings',
          component: AiKnowledgeSourceIndex,
          meta: {
            permissions: ['administrator'],
            flushSettingsContent: true,
          },
        },
      ],
    },
  ],
};
